import { isReplyingToFollowUp } from './shared-responder-v2-core-follow-up-reply.helpers';
import { isHandsFreeDelivery } from './shared-responder-v2-core-handsfree.selectors';
import {
  RESPONDER_PHASES,
  RESPONSE_MODES,
} from './shared-responder-v2-core-session.consts';
import {
  selectCurrentSpec,
  selectCurrentThread,
  selectEffectiveMode,
} from './shared-responder-v2-core-session.selectors';
import type { ResponderSessionState } from './shared-responder-v2-core-session.types';
import { THREAD_KINDS } from './shared-responder-v2-core-thread.consts';

function isVoiceDelivered(state: ResponderSessionState): boolean {
  return (
    selectEffectiveMode(state) === RESPONSE_MODES.Voice ||
    isHandsFreeDelivery(state)
  );
}

/**
 * The voice-mode questions whose answer is still typed: Contact Info (the backend rejects a
 * spoken attempt with "please type your email address") and an open-ended question the author
 * set to text. Hands-free doesn't override either — the AI still reads the question aloud and
 * the mic stays live (`shouldKeepMicrophoneLive` covers the same two kinds), but the answer is typed.
 */
export function selectRequiresTypedComposer(
  state: ResponderSessionState
): boolean {
  if (state.phase !== RESPONDER_PHASES.Question || !isVoiceDelivered(state)) {
    return false;
  }

  const spec = selectCurrentSpec(state);

  if (spec === null) {
    return false;
  }

  if (spec.kind === THREAD_KINDS.ContactInfo) {
    return true;
  }

  return (
    spec.kind === THREAD_KINDS.OpenEnded &&
    spec.interactionType === RESPONSE_MODES.Text
  );
}

export function selectShowsVoiceCluster(state: ResponderSessionState): boolean {
  if (state.phase !== RESPONDER_PHASES.Question) {
    return false;
  }

  return isVoiceDelivered(state) && !selectRequiresTypedComposer(state);
}

export function selectIsAwaitingVoiceFollowUpReply(
  state: ResponderSessionState
): boolean {
  const thread = selectCurrentThread(state);

  return (
    thread !== null &&
    selectShowsVoiceCluster(state) &&
    isReplyingToFollowUp(state, thread.questionId)
  );
}
